import React from 'react';
import { t } from '@lingui/macro';

import { ServiceType } from '@rover/constants/src/translations/service.constants';
import { SERVICE_SELECTION_OPTIONS } from '@rover/constants/src/translations/serviceSelector.constants';
import { Box, Heading } from '@rover/kibble/core';
import Location from '@rover/react-lib/src/pages/search/SearchPage/components/Filters/Location';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import MobileServiceSelector from '@rover/shared/js/search/components/MobileServiceSelector';
import type { SearchFiltersOptions } from '@rover/types/src/apiResponses/SearchOptionsResponse';
import type { SearchFilters } from '@rover/types/src/SearchFilters';

import { SearchInterstitialUpdateLocation } from '../../Filters/Collections/Wizard/analyticsEvents';

import DateAvailabilitySection from './DateAvailabilitySection';

export type ServiceSectionProps = {
  serviceType?: ServiceType;
  location?: string;
  searchFilters: SearchFilters;
  onFiltersChange: (filters: Partial<SearchFilters>) => void;
  serviceTypeFilterOptions: SearchFiltersOptions;
  language: string;
  isCatOnly: boolean;
};

const ServiceSection = ({
  serviceType,
  location,
  searchFilters,
  onFiltersChange,
  serviceTypeFilterOptions,
  language,
  isCatOnly,
}: ServiceSectionProps): JSX.Element => {
  // we are restricting the service options shown based on pet type
  const items = isCatOnly ? 3 : 5;
  const serviceOptions = SERVICE_SELECTION_OPTIONS().slice(0, items);
  const selectedService = serviceOptions.find((option) => option.value === serviceType);
  const selectedServiceType = selectedService?.value || serviceOptions[0].value;

  const handleLocationChange = (filters: Partial<SearchFilters>): void => {
    onFiltersChange(filters);
    emitAnalyticsEvent(new SearchInterstitialUpdateLocation());
  };

  return (
    <Box pt="6x" pb="4x" borderBottom="1px solid" borderBottomColor="separator.primary">
      <Heading size="300" mb="4x">
        {t`Service`}
      </Heading>
      <MobileServiceSelector
        serviceTypeOptions={serviceOptions}
        selected={selectedServiceType}
        onChange={onFiltersChange}
      />
      <Box mt="6x">
        <Location
          label={t`Address`}
          onChange={handleLocationChange}
          location={location}
          locationInputId="primary-filters-location-input"
          inputHeight="48px"
        />
      </Box>
      <DateAvailabilitySection
        searchFilters={searchFilters}
        onFiltersChange={onFiltersChange}
        language={language}
        serviceType={selectedServiceType}
        serviceTypeFilterOptions={serviceTypeFilterOptions}
      />
    </Box>
  );
};

export default ServiceSection;
